/* @flow */
import UserAnalyticsService from 'common/services/UserAnalyticsService';

export const onPageLoadEnd = ({
    clientId,
    pageName
}: {
    clientId: string,
    pageName: string
}) => {
    UserAnalyticsService.setPageName(pageName);
    UserAnalyticsService.setPageLoadEndTime(performance.now(), clientId);
};

export const onPageLoadStart = () => {
    UserAnalyticsService.setPageLoadStartTime(performance.now());
};
